import { Controller } from "@hotwired/stimulus"
import { showToast } from "../utils/toast"
import { copyToClipboard } from "../utils/clipboard"

export default class extends Controller {
  static targets = ["text"]
  static values = {
    successText: { type: String, default: "Copied to clipboard" },
    failureText: { type: String, default: "Failed to copy. Please try again." }
  }

  async copy() {
    const text = this.textTarget.textContent.trim()
    const copied = await copyToClipboard(text)

    if (copied) {
      showToast(this.successTextValue)
    } else {
      showToast(this.failureTextValue, "alert")
    }
  }
}
